export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

/**
 * Generate login URL at runtime.
 * 
 * Dual-environment logic:
 * - Inside Manus (VITE_OAUTH_PORTAL_URL set): uses Manus OAuth flow
 * - Outside Manus (Northflank/prod): redirects to /login (independent auth)
 */
export const getLoginUrl = (returnPath?: string) => {
  const oauthPortalUrl = import.meta.env.VITE_OAUTH_PORTAL_URL;
  const appId = import.meta.env.VITE_APP_ID;

  // If Manus OAuth env vars are available, use Manus OAuth
  if (oauthPortalUrl && appId) {
    const redirectUri = `${window.location.origin}/api/oauth/callback`;
    const state = btoa(redirectUri);

    const url = new URL(`${oauthPortalUrl}/app-auth`);
    url.searchParams.set("appId", appId);
    url.searchParams.set("redirectUri", redirectUri);
    url.searchParams.set("state", state);
    url.searchParams.set("type", "signIn");

    return url.toString();
  }

  // Outside Manus: use independent auth (/login page)
  return returnPath ? `/login?redirect=${encodeURIComponent(returnPath)}` : "/login";
};
